import { api } from '../../api'

const putUsersFromFeide = () => {
  return api.put('/user-groups/feide/user-group')
}

export default {
  put: putUsersFromFeide
}
